"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Textarea: function() {
        return _index.Textarea;
    },
    renderTextarea_unstable: function() {
        return _index.renderTextarea_unstable;
    },
    textareaClassNames: function() {
        return _index.textareaClassNames;
    },
    useTextareaStyles_unstable: function() {
        return _index.useTextareaStyles_unstable;
    },
    useTextarea_unstable: function() {
        return _index.useTextarea_unstable;
    }
});
const _index = require("./components/Textarea/index");
